import type { ReactNode } from 'react';
import classnames from 'classnames';
import React from 'react';
import * as styles from './MediaObject.module.scss';

interface IMediaObjectProps {
    children?: ReactNode;
    mediaItem: React.JSX.Element;
    title?: string;
    titleClassName?: string;
}

export default function MediaObject(props: IMediaObjectProps) {
    return (
        <div className={styles.media}>
            <figure className={styles.mediaCenter}>
                <div className={styles.mediaItem}>{props.mediaItem}</div>
            </figure>
            <div className={styles.mediaContent}>
                <div className={styles.content}>
                    {props.title && (
                        <h3 className={classnames(styles.title, props.titleClassName || '')}>{props.title}</h3>
                    )}
                    {props.children}
                </div>
            </div>
        </div>
    );
}
